import ResponseModal from "../../../global/ResponseModal";

export default function ErrorModal({ title, desc, open, setOpen, errorArray }) {
  return (
    <ResponseModal
      title={title}
      description={desc}
      isError
      openBool={open}
      setOpenBool={setOpen}
      errorMessage={errorArray}
    />
  );
}